export enum BUTTON_TYPES {
  CALLBACK = "callback",
  LINK = "link",
}
